import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect, useCallback, useMemo, } from "react";
import { Input } from "@material-tailwind/react";
function SearchableSelect({ label, options, selectedItems, onAdd, getOptionLabel, }) {
    const [search, setSearch] = useState("");
    const [show, setShow] = useState(false);
    const containerRef = useRef(null);
    // Default getOptionLabel function:
    const defaultGetOptionLabel = useCallback((option) => typeof option === "string" ? option : option.label, []);
    // Use provided getOptionLabel or default one.
    const optionLabel = getOptionLabel || defaultGetOptionLabel;
    // Filter options based on search input and that are not already selected.
    const filteredOptions = useMemo(() => {
        return options.filter((option) => optionLabel(option).toLowerCase().includes(search.toLowerCase()) &&
            !selectedItems.some((selected) => optionLabel(selected).toLowerCase() === optionLabel(option).toLowerCase()));
    }, [options, search, selectedItems, optionLabel]);
    // Close dropdown if click occurs outside.
    const handleClickOutside = useCallback((event) => {
        if (containerRef.current &&
            !containerRef.current.contains(event.target)) {
            setShow(false);
        }
    }, []);
    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [handleClickOutside]);
    // Open the dropdown when the input gains focus.
    const handleFocus = useCallback(() => {
        setShow(true);
    }, []);
    // Handle selection of an option.
    const handleSelect = useCallback((option) => {
        onAdd(option);
        setSearch("");
        setShow(false);
    }, [onAdd]);
    return (_jsxs("div", { className: "mt-4 relative", ref: containerRef, children: [_jsx(Input, { variant: "standard", type: "text", placeholder: `${label}`, label: `${label}`, value: search, onChange: (e) => setSearch(e.target.value), onFocus: handleFocus, crossOrigin: "", "aria-haspopup": "listbox", "aria-expanded": show }), show && (_jsx("div", { className: "absolute top-full left-0 w-full bg-white border border-gray-300 rounded z-10", role: "listbox", "aria-label": `Options de ${label}`, children: filteredOptions.length > 0 ? (_jsx("ul", { className: "max-h-48 overflow-y-auto", children: filteredOptions.map((option) => (_jsx("li", { className: "px-3 py-2 hover:bg-gray-100 cursor-pointer", role: "option", onClick: () => handleSelect(option), children: optionLabel(option) }, optionLabel(option)))) })) : (_jsx("div", { className: "px-3 py-2 text-gray-500", children: "Aucune option disponible" })) }))] }));
}
export default SearchableSelect;
